import { Link } from 'react-router-dom';
import { ArrowRight, CalendarCheck } from 'lucide-react';
import Reveal from '../components/animation/Reveal';
import HeroVisual from '../components/hero/HeroVisual';
import ServicePreview from '../components/services/ServicePreview';
import { businessDetails } from '../data/siteContent';

function HomePage() {
  return (
    <>
      <section className="hero-section">
        <div className="hero-backdrop" />
        <div className="hero-content">
          <div className="hero-layout">
            <div className="hero-copy-block">
              <p className="hero-kicker">{businessDetails.address}</p>
              <h1>Special tailoring for men's dishdasha in Kuwait City.</h1>
              <p className="hero-copy">
                Saqar Al-Jazeera provides precise men's tailoring, dishdasha stitching, alterations, and fabric guidance from Souk Al-Wajef, Qibla.
              </p>
              <div className="hero-actions">
                <Link className="primary-action" to="/contact">
                  <CalendarCheck size={19} />
                  Book a fitting
                </Link>
                <Link className="secondary-action" to="/services">
                  View services
                  <ArrowRight size={18} />
                </Link>
              </div>
            </div>
            <HeroVisual />
          </div>
        </div>
      </section>

      <Reveal as="section" className="section intro-grid">
        <div>
          <p className="section-label">What we make</p>
          <h2>Clean dishdasha tailoring with reliable measurements and finishing.</h2>
        </div>
        <div className="intro-copy">
          <p>
            From fabric selection to final fitting, each order is handled with measurement discipline, practical advice, and finishing details suited for daily wear in Kuwait.
          </p>
          <div className="stat-row">
            <span><strong>01</strong> Consultation</span>
            <span><strong>02</strong> Measurement</span>
            <span><strong>03</strong> Delivery</span>
          </div>
        </div>
      </Reveal>

      <ServicePreview />
    </>
  );
}

export default HomePage;
